module.exports = __webpack_public_path__ + "static/media/agroRejestrCover.8032fb2f.jpeg";